import TermsAndConditions from "components/terms-conditions";

export default TermsAndConditions;
